export const TOASTS = [
    { date: new Date(2024, 15, 5), id: '15.05', isActive: true },
    { date: new Date(2024, 11, 8), id: '08.11', isActive: true },
];
export const TOAST_AUTO_CLOSE_DURATION = 5000;
